import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function PricingPage() {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-8 bg-gradient-to-b from-pink-200 to-white">
      <div className="w-full max-w-4xl flex flex-col items-center bg-white/90 rounded-2xl shadow-lg p-8 md:p-12">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-800 mb-6 text-center">
          {t('pricing.title')}
        </h1>
        <p className="text-xl text-gray-600 mb-8 text-center">
          {t('pricing.description')}
        </p>
        
        {/* Pricing Content */}
        <div className="w-full max-w-2xl bg-gray-50 rounded-xl p-8 mb-8">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              {t('pricing.valueTitle')}
            </h2>
            <p className="text-gray-600 text-lg">
              {t('pricing.valueDescription')}
            </p>
          </div>
        </div>

        {/* Contact Options */}
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md mb-8">
          <a
            href="https://wa.me/905372243441"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 px-6 py-4 bg-green-500 hover:bg-green-600 text-white text-lg font-semibold rounded-xl transition shadow-md flex items-center justify-center gap-3"
          >
            <FaWhatsapp size={48} />
            {t('pricing.whatsappButton')}
          </a>
          
          <a
            href="https://instagram.com/weddingram.me"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 px-6 py-4 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white text-lg font-semibold rounded-xl transition shadow-md flex items-center justify-center gap-3"
          >
            <FaInstagram size={48} />
            {t('pricing.instagramButton')}
          </a>
        </div>

        <div className="w-full max-w-2xl bg-gray-50 rounded-xl p-8 mb-8">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              {t('pricing.updateNotice')}
            </h2>
            <p className="text-gray-600 text-lg">
              {t('pricing.updateDescription')}
            </p>
          </div>
        </div>

        {/* Back to Home */}
        <Link
          to="/"
          className="mt-8 px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white font-semibold rounded-xl transition shadow-md"
        >
          {t('pricing.homeButton')}
        </Link>
      </div>
    </div>
  );
}

export default PricingPage; 